import React from 'react';

import type { RowType } from '@atlaskit/dynamic-table/types';
import type { LocalOverrides } from '@atlaskit/feature-gate-js-client';
import Toggle from '@atlaskit/toggle';

import { clearGateOverride, overrideGate } from '../../../../common/persistance';
import { DeleteButton } from '../../delete-button';

export const TABLE_COLUMN_HEADINGS = {
	cells: [
		{ key: 'entity', content: 'Entity', isSortable: true },
		{ key: 'name', content: 'Name', isSortable: true, shouldTruncate: false },
		{ key: 'value', content: 'Value', isSortable: true },
		{ key: 'actions', content: 'Actions' },
	],
};

export const getRows = (overrides: LocalOverrides, updateOverrides: () => void) => {
	const rows: RowType[] = [];
	Object.entries(overrides.gates).forEach(([name, value]) => {
		rows.push({
			key: `row-gate-${name}`,
			cells: [
				{ key: 'entity-gate', content: 'Gate' },
				{ key: name, content: name },
				{
					key: `value-${JSON.stringify(value)}`,
					content: (
						<Toggle
							isChecked={value}
							onChange={(event) => {
								const newValue = event.target.checked;
								overrideGate(name, newValue);
								updateOverrides();
							}}
						/>
					),
				},
				{
					key: `action-${name}`,
					content: (
						<DeleteButton
							onClick={() => {
								clearGateOverride(name);
								updateOverrides();
							}}
						/>
					),
				},
			],
		});
	});

	return rows;
};
